"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diseases = void 0;
const opade_1 = require("./opade-study/opade");
const organisations_1 = require("../../model/organisations");
const _diseases = [
    opade_1.opadeStudy,
];
exports.diseases = _diseases.map((disease) => (Object.assign(Object.assign({}, disease), { type: "disease", organisations: disease.organisations.map((organisation) => (0, organisations_1.mergeToOrganisationConfig)(disease, organisation)) })));
